import { useState } from "react";
import { Browser } from "@capacitor/browser";
import { api, API } from "@/lib/api";
import { isNative } from "@/lib/session";

// Web: plain link (session cookie). Native: the system browser has no Bearer
// session, so fetch a short-lived signed download link first.
export const CertificateLink = ({ trackId, className, style, children, testId }) => {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const href = `${API}/tracks/${trackId}/certificate`;

  const onClick = async (e) => {
    if (!isNative) return;
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      const { token } = await api.certificateLink(trackId);
      await Browser.open({ url: `${href}?dl=${token}`, toolbarColor: "#0c0a1a" });
    } catch (err) {
      setError(err?.response?.data?.detail || "تعذّر فتح الشهادة. تحقّق من الاتصال وحاول مجدّدًا.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <a
        className={className}
        style={style}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        onClick={onClick}
        aria-busy={busy}
        data-testid={testId}
      >
        {busy ? "جارٍ تجهيز الشهادة…" : children}
      </a>
      {error && (
        <div className="hint" role="alert" style={{ color: "#ff7aa8", marginTop: 6 }} data-testid={`${testId}-error`}>
          {error}
        </div>
      )}
    </>
  );
};
